/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:ea6d94af-a531-410d-8429-1c952abcbe0b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_sntrRfn11",
    "aws_user_pools_web_client_id": "3j98b0o5vflm5s1ev9if519vhd",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "joshdlee-music204129-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
